module.exports = __webpack_public_path__ + "static/media/stade.b22b2971.jpg";